import { styled } from '@mui/material/styles'

const AuthWrapper = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.grey[150],
  minHeight: '100vh',
}))

export default AuthWrapper
